import React, { useState } from "react";
import plus from "../assets/img/plus.png";
import minus from "../assets/img/minus.png";
import dot from "../assets/img/dott.png";

interface SubCategory {
  id: string | number;
  name: string;
}

interface Category {
  id: string | number;
  name: string;
  items?: SubCategory[];
}

interface CategoryAccordionListProps {
  items: Category[];
  onCategoryClick: (id: string | number, name: string) => void;
  setFilteredCategoryId?: (id: string | number) => void;
  setSelectedCategoryName?: (name: string) => void;
  isSelected: boolean;
  setSelectedSubId: any;
  setSelectedParentId: any;
  selectedParentId: any;
  selectedSubId: any;
  onExpandCategory?: (categoryId: string) => void;
}

const CategoryAccordionList: React.FC<CategoryAccordionListProps> = ({
  items,
  onCategoryClick,
  setFilteredCategoryId,
  setSelectedCategoryName,
  setSelectedSubId,
  setSelectedParentId,
  selectedParentId,
  selectedSubId,
  onExpandCategory

}) => {
  const [openCategoryId, setOpenCategoryId] = useState<string | number | null>(null);
  const [hoveredParentId, setHoveredParentId] = useState<
    string | number | null
  >(null);

  const [hoveredSubId, setHoveredSubId] = useState<
    string | number | null
  >(null);

  const handleParentClick = (category: Category) => {
    if (category.items && category.items.length > 0) {
      // Category already has subcategories, just toggle
      setOpenCategoryId(openCategoryId === category.id ? null : category.id);
    } else {
      // Category has no items, try to fetch subcategories first
      if (onExpandCategory && category.id) {
        onExpandCategory(category.id.toString());
      }
      setOpenCategoryId(openCategoryId === category.id ? null : category.id);

      // If still no subcategories after fetch, treat as a video category
      setTimeout(() => {
        const categoryWithItems = items.find(cat => cat.id === category.id);
        if (!categoryWithItems?.items || categoryWithItems.items.length === 0) {
          onCategoryClick(category.id, category.name);
          setSelectedSubId(null);
          setSelectedParentId(category.id);
          setSelectedCategoryName?.(category.name);
          setFilteredCategoryId?.(category.id);
        }
      }, 100);
    }
  };

  const handleChildClick = (sub: SubCategory, category: Category) => {
    setSelectedParentId(null);
    setSelectedSubId(sub.id);
    setFilteredCategoryId?.(sub.id);
    setSelectedCategoryName?.(`${category.name} / ${sub.name}`);
    onCategoryClick(sub.id, sub.name);
  };

  return (
    <div style={{ marginTop: "1px", background: "#FFFAF0", padding: "8px" }}>
      {items?.map((category: any, index: number) => {
        const isOpen = openCategoryId === category.id;
        const hasChildren = category.items?.length > 0;
        const iconSrc = hasChildren ? (isOpen ? minus : plus) : dot;

        return (
          <ul
            key={index}
            style={{
              color: "orange",
              fontSize: "18px",
              cursor: "pointer",
              lineHeight: 1,
              marginTop: 3,
              marginLeft: "-45px"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onClick={() => handleParentClick(category)}
            >
              <img src={iconSrc} alt="icon" width="20px" style={{ marginRight: "5px" }} />
              {/* <span
                style={{
                  color: selectedParentId === category.id ? "red" : "#545454",
                  fontSize: "21px",
                }}
              >
                {category.name}
              </span> */}

              <h2
              style={{
                color:
                  selectedParentId === category.id
                    ? "red"
                    : hoveredParentId === category.id
                    ? "#cf2c24"
                    : "#545454",
                fontSize: "21px",
                transition: "0.2s ease",
                cursor: "pointer",
              }}
              onMouseEnter={() => setHoveredParentId(category.id)}
              onMouseLeave={() => setHoveredParentId(null)}
            >
              {category.name}
            </h2>
            </div>

            {hasChildren && isOpen && (
              <ul style={{ marginTop: 4, marginLeft: 28 }}>
                {category.items.map((sub: any, subIndex: number) => (
                  <li key={subIndex} style={{ marginTop: 12 }}>
                    <h3
                      style={{
                        fontSize: "20px",
                        fontWeight: 500,
                        cursor: "pointer",
                          color:
                          selectedSubId === sub.id
                            ? "red"
                            : hoveredSubId === sub.id
                            ? "#cf2c24"
                            : "black",
                        transition: "0.2s ease",
                      }}
                        onMouseEnter={() => setHoveredSubId(sub.id)}
                       onMouseLeave={() => setHoveredSubId(null)}
                      onClick={() => handleChildClick(sub, category)}
                    >
                      {sub.name}
                    </h3>
                  </li>
                ))}
              </ul>
            )}
          </ul>
        );
      })}
    </div>
  );
};

export default CategoryAccordionList;
